import { atom } from "jotai";
import { type SurveyActionType } from "../config/survey-input";
import { SurveyCurrentStep } from "../entities/survey-current-step";

const initialStep = new SurveyCurrentStep();
export const surveyCurrentStepAtom = atom<SurveyCurrentStep>(initialStep);

export const surveyIsFetchingDataAtom = atom<(typeof SurveyActionType)[keyof typeof SurveyActionType] | false>(false);
